module.exports = __webpack_public_path__ + "img/group_bg.e0118d7d.jpg";